import { Box } from '@mui/material';
import React from 'react';
import { ActionButton, convertActionsToMenuItems } from '../../ActionButton';
import { useCommonDataTableUiTranslation } from '../../hooks';
export const GlobalActionsMedium = (props) => {
    const { t } = useCommonDataTableUiTranslation();
    if (props.globalActions && props.globalActions.length > 0) {
        if (props.globalActions.length === 1) {
            return React.createElement(ActionButton, { fullWidth: true, action: props.globalActions[0], variant: 'outlined' });
        }
        else if (props.globalActions.length === 2) {
            return (React.createElement(Box, { sx: { display: 'grid', gridTemplateColumns: (theme) => `repeat(2, calc(50% - ${theme.spacing(1)}))`, gap: 2 } },
                React.createElement(ActionButton, { action: props.globalActions[0], variant: 'outlined' }),
                React.createElement(ActionButton, { action: props.globalActions[1], variant: 'outlined' })));
        }
        else {
            const lastAction = props.globalActions[props.globalActions.length - 1];
            const otherActions = props.globalActions.slice(1, props.globalActions.length - 1);
            return (React.createElement(Box, { sx: { display: 'grid', gridTemplateColumns: (theme) => `repeat(2, calc(50% - ${theme.spacing(1)}))`, gap: 2 } },
                React.createElement(ActionButton, { action: {
                        label: t('actions'),
                        menuItems: convertActionsToMenuItems(otherActions),
                        'data-test': 'other-global-actions-menu',
                    }, anchor: 'left', variant: 'outlined' }),
                React.createElement(ActionButton, { action: lastAction, variant: 'outlined' })));
        }
    }
    else {
        return null;
    }
};
